// Primary 5 Mathematics Data - 小學五年級數學數據
export const p5MathsData = {
  title: '小學五年級數學',
  description: '深入學習數學概念，掌握更複雜的運算技能',
  grade: 'P5',
  year: '小學五年級',
  
  topics: [
    {
      id: 'p5-5n1',
      code: '5N1',
      title: '小數',
      description: '認識小數的基本概念',
      objectives: [
        '認識小數的概念',
        '學會讀寫小數',
        '理解小數的位值',
        '學會小數的比較'
      ],
      sampleQuestions: [
        {
          id: 'p5-5n1-q1',
          question: '寫出小數：三點五',
          answer: '3.5',
          solution: '三點五用小數表示是3.5',
          difficulty: 'basic'
        },
        {
          id: 'p5-5n1-q2',
          question: '讀出小數：2.75',
          answer: '二點七五',
          solution: '2.75讀作二點七五',
          difficulty: 'basic'
        },
        {
          id: 'p5-5n1-q3',
          question: '比較大小：3.25 和 3.5',
          answer: '3.25 < 3.5',
          solution: '3.25 < 3.5\n小數部分0.25 < 0.5',
          difficulty: 'intermediate'
        },
        {
          id: 'p5-5n1-q4',
          question: '在2.5到3.0之間有多少個一位小數？',
          answer: '4個',
          solution: '2.5到3.0之間的一位小數是：2.6, 2.7, 2.8, 2.9，共4個。',
          difficulty: 'intermediate'
        },
        {
          id: 'p5-5n1-q5',
          question: '寫出比2.99大0.01的數。',
          answer: '3.00',
          solution: '2.99 + 0.01 = 3.00',
          difficulty: 'advanced'
        }
      ]
    },
    {
      id: 'p5-5n2',
      code: '5N2',
      title: '小數的加減法',
      description: '學習小數的加減法運算',
      objectives: [
        '學會小數的加法',
        '學會小數的減法',
        '理解小數的進位和退位',
        '解決小數的應用題'
      ],
      sampleQuestions: [
        {
          id: 'p5-5n2-q1',
          question: '計算：2.5 + 3.7 = ?',
          answer: '6.2',
          solution: '2.5 + 3.7 = 6.2\n小數點對齊，按位相加。',
          difficulty: 'basic'
        },
        {
          id: 'p5-5n2-q2',
          question: '計算：5.8 - 2.3 = ?',
          answer: '3.5',
          solution: '5.8 - 2.3 = 3.5\n小數點對齊，按位相減。',
          difficulty: 'basic'
        },
        {
          id: 'p5-5n2-q3',
          question: '小明有12.5元，買了一本書花了8.7元，還剩下多少元？',
          answer: '3.8元',
          solution: '12.5 - 8.7 = 3.8\n小明還剩下3.8元。',
          difficulty: 'intermediate'
        },
        {
          id: 'p5-5n2-q4',
          question: '計算：3.25 + 4.75 + 2.5 = ?',
          answer: '10.5',
          solution: '3.25 + 4.75 + 2.5 = 10.5\n先算：3.25 + 4.75 = 8\n再算：8 + 2.5 = 10.5',
          difficulty: 'intermediate'
        },
        {
          id: 'p5-5n2-q5',
          question: '小華有15.8元，買了兩本書，第一本花了6.3元，第二本花了4.2元，還剩下多少元？',
          answer: '5.3元',
          solution: '15.8 - 6.3 - 4.2 = 5.3\n先算：15.8 - 6.3 = 9.5\n再算：9.5 - 4.2 = 5.3',
          difficulty: 'advanced'
        }
      ]
    },
    {
      id: 'p5-5n3',
      code: '5N3',
      title: '小數的乘法',
      description: '學習小數的乘法運算',
      objectives: [
        '學會小數乘以整數',
        '學會小數乘以小數',
        '理解小數乘法的進位',
        '解決小數乘法應用題'
      ],
      sampleQuestions: [
        {
          id: 'p5-5n3-q1',
          question: '計算：2.5 × 4 = ?',
          answer: '10',
          solution: '2.5 × 4 = 10\n先算25 × 4 = 100，再點小數點。',
          difficulty: 'basic'
        },
        {
          id: 'p5-5n3-q2',
          question: '計算：3.2 × 2.5 = ?',
          answer: '8',
          solution: '3.2 × 2.5 = 8\n先算32 × 25 = 800，再點小數點。',
          difficulty: 'basic'
        },
        {
          id: 'p5-5n3-q3',
          question: '小明買了3.5斤蘋果，每斤2.8元，一共要付多少元？',
          answer: '9.8元',
          solution: '3.5 × 2.8 = 9.8\n小明一共要付9.8元。',
          difficulty: 'intermediate'
        },
        {
          id: 'p5-5n3-q4',
          question: '計算：4.5 × 1.2 = ?',
          answer: '5.4',
          solution: '4.5 × 1.2 = 5.4\n先算45 × 12 = 540，再點小數點。',
          difficulty: 'intermediate'
        },
        {
          id: 'p5-5n3-q5',
          question: '小華買了2.5米布，每米12.8元，一共要付多少元？',
          answer: '32元',
          solution: '2.5 × 12.8 = 32\n小華一共要付32元。',
          difficulty: 'advanced'
        }
      ]
    },
    {
      id: 'p5-5n4',
      code: '5N4',
      title: '小數的除法',
      description: '學習小數的除法運算',
      objectives: [
        '學會小數除以整數',
        '學會小數除以小數',
        '理解小數除法的概念',
        '解決小數除法應用題'
      ],
      sampleQuestions: [
        {
          id: 'p5-5n4-q1',
          question: '計算：8.4 ÷ 4 = ?',
          answer: '2.1',
          solution: '8.4 ÷ 4 = 2.1\n先算84 ÷ 4 = 21，再點小數點。',
          difficulty: 'basic'
        },
        {
          id: 'p5-5n4-q2',
          question: '計算：12.6 ÷ 3 = ?',
          answer: '4.2',
          solution: '12.6 ÷ 3 = 4.2\n先算126 ÷ 3 = 42，再點小數點。',
          difficulty: 'basic'
        },
        {
          id: 'p5-5n4-q3',
          question: '小明有15.6元，要買4本書，每本書多少元？',
          answer: '3.9元',
          solution: '15.6 ÷ 4 = 3.9\n每本書3.9元。',
          difficulty: 'intermediate'
        },
        {
          id: 'p5-5n4-q4',
          question: '計算：18.9 ÷ 7 = ?',
          answer: '2.7',
          solution: '18.9 ÷ 7 = 2.7\n先算189 ÷ 7 = 27，再點小數點。',
          difficulty: 'intermediate'
        },
        {
          id: 'p5-5n4-q5',
          question: '小華有25.5元，要買5個蘋果，每個蘋果多少元？',
          answer: '5.1元',
          solution: '25.5 ÷ 5 = 5.1\n每個蘋果5.1元。',
          difficulty: 'advanced'
        }
      ]
    },
    {
      id: 'p5-5n5',
      code: '5N5',
      title: '分數(三)',
      description: '進一步學習分數概念',
      objectives: [
        '學會分數的乘法',
        '學會分數的除法',
        '理解分數的約分和通分',
        '解決分數應用題'
      ],
      sampleQuestions: [
        {
          id: 'p5-5n5-q1',
          question: '計算：2/3 × 3/4 = ?',
          answer: '1/2',
          solution: '2/3 × 3/4 = 6/12 = 1/2\n分子相乘，分母相乘，再約分。',
          difficulty: 'basic'
        },
        {
          id: 'p5-5n5-q2',
          question: '計算：3/4 ÷ 1/2 = ?',
          answer: '3/2',
          solution: '3/4 ÷ 1/2 = 3/4 × 2/1 = 6/4 = 3/2\n除以分數等於乘以倒數。',
          difficulty: 'basic'
        },
        {
          id: 'p5-5n5-q3',
          question: '小明有1/2個蛋糕，小華有1/3個蛋糕，兩人一共有多少個蛋糕？',
          answer: '5/6個',
          solution: '1/2 + 1/3 = 3/6 + 2/6 = 5/6\n通分後相加。',
          difficulty: 'intermediate'
        },
        {
          id: 'p5-5n5-q4',
          question: '計算：4/5 × 2/3 = ?',
          answer: '8/15',
          solution: '4/5 × 2/3 = 8/15\n分子相乘，分母相乘。',
          difficulty: 'intermediate'
        },
        {
          id: 'p5-5n5-q5',
          question: '小華有3/4個蘋果，要分給2個小朋友，每人分到多少？',
          answer: '3/8個',
          solution: '3/4 ÷ 2 = 3/4 × 1/2 = 3/8\n每人分到3/8個蘋果。',
          difficulty: 'advanced'
        }
      ]
    },
    {
      id: 'p5-5m1',
      code: '5M1',
      title: '體積',
      description: '認識體積的概念和計算',
      objectives: [
        '認識體積的概念',
        '學會計算立方體的體積',
        '理解體積的單位',
        '解決體積相關的應用題'
      ],
      sampleQuestions: [
        {
          id: 'p5-5m1-q1',
          question: '立方體的體積公式是什麼？',
          answer: '邊長 × 邊長 × 邊長',
          solution: '立方體的體積 = 邊長 × 邊長 × 邊長\n或寫作：體積 = 邊長³',
          difficulty: 'basic'
        },
        {
          id: 'p5-5m1-q2',
          question: '長方體的體積公式是什麼？',
          answer: '長 × 寬 × 高',
          solution: '長方體的體積 = 長 × 寬 × 高',
          difficulty: 'basic'
        },
        {
          id: 'p5-5m1-q3',
          question: '一個立方體的邊長是3厘米，體積是多少？',
          answer: '27立方厘米',
          solution: '3 × 3 × 3 = 27\n立方體的體積是27立方厘米。',
          difficulty: 'intermediate'
        },
        {
          id: 'p5-5m1-q4',
          question: '一個長方體的長是5厘米，寬是4厘米，高是3厘米，體積是多少？',
          answer: '60立方厘米',
          solution: '5 × 4 × 3 = 60\n長方體的體積是60立方厘米。',
          difficulty: 'intermediate'
        },
        {
          id: 'p5-5m1-q5',
          question: '一個長方體的體積是120立方厘米，長是6厘米，寬是5厘米，高是多少？',
          answer: '4厘米',
          solution: '120 ÷ (6 × 5) = 120 ÷ 30 = 4\n長方體的高是4厘米。',
          difficulty: 'advanced'
        }
      ]
    },
    {
      id: 'p5-5m2',
      code: '5M2',
      title: '時間(三)',
      description: '進一步學習時間概念',
      objectives: [
        '學會時間的乘除法',
        '理解時間的換算',
        '學會時間的估算',
        '解決時間相關的應用題'
      ],
      sampleQuestions: [
        {
          id: 'p5-5m2-q1',
          question: '2小時30分鐘等於多少分鐘？',
          answer: '150分鐘',
          solution: '2小時30分鐘 = 2 × 60 + 30 = 120 + 30 = 150分鐘',
          difficulty: 'basic'
        },
        {
          id: 'p5-5m2-q2',
          question: '180分鐘等於多少小時？',
          answer: '3小時',
          solution: '180 ÷ 60 = 3\n180分鐘等於3小時。',
          difficulty: 'basic'
        },
        {
          id: 'p5-5m2-q3',
          question: '小明做功課用了1小時30分鐘，小華用了2小時15分鐘，兩人一共用了多少時間？',
          answer: '3小時45分鐘',
          solution: '1小時30分鐘 + 2小時15分鐘 = 3小時45分鐘',
          difficulty: 'intermediate'
        },
        {
          id: 'p5-5m2-q4',
          question: '小華每天做功課2小時，一週做功課多少小時？',
          answer: '14小時',
          solution: '2 × 7 = 14\n一週做功課14小時。',
          difficulty: 'intermediate'
        },
        {
          id: 'p5-5m2-q5',
          question: '小明一週做功課21小時，平均每天做功課多少小時？',
          answer: '3小時',
          solution: '21 ÷ 7 = 3\n平均每天做功課3小時。',
          difficulty: 'advanced'
        }
      ]
    },
    {
      id: 'p5-5s1',
      code: '5S1',
      title: '圓形(二)',
      description: '進一步學習圓形概念',
      objectives: [
        '學會計算圓的周長',
        '學會計算圓的面積',
        '理解圓周率的概念',
        '解決圓形相關的應用題'
      ],
      sampleQuestions: [
        {
          id: 'p5-5s1-q1',
          question: '圓的周長公式是什麼？',
          answer: '2 × π × 半徑',
          solution: '圓的周長 = 2 × π × 半徑\n或寫作：周長 = 2πr',
          difficulty: 'basic'
        },
        {
          id: 'p5-5s1-q2',
          question: '圓的面積公式是什麼？',
          answer: 'π × 半徑²',
          solution: '圓的面積 = π × 半徑²\n或寫作：面積 = πr²',
          difficulty: 'basic'
        },
        {
          id: 'p5-5s1-q3',
          question: '一個圓的半徑是5厘米，周長是多少？（π取3.14）',
          answer: '31.4厘米',
          solution: '2 × 3.14 × 5 = 31.4\n圓的周長是31.4厘米。',
          difficulty: 'intermediate'
        },
        {
          id: 'p5-5s1-q4',
          question: '一個圓的半徑是4厘米，面積是多少？（π取3.14）',
          answer: '50.24平方厘米',
          solution: '3.14 × 4² = 3.14 × 16 = 50.24\n圓的面積是50.24平方厘米。',
          difficulty: 'intermediate'
        },
        {
          id: 'p5-5s1-q5',
          question: '一個圓的周長是31.4厘米，半徑是多少？（π取3.14）',
          answer: '5厘米',
          solution: '31.4 ÷ (2 × 3.14) = 31.4 ÷ 6.28 = 5\n圓的半徑是5厘米。',
          difficulty: 'advanced'
        }
      ]
    },
    {
      id: 'p5-5s2',
      code: '5S2',
      title: '三角形(二)',
      description: '進一步學習三角形概念',
      objectives: [
        '學會計算三角形的面積',
        '學會計算三角形的周長',
        '理解三角形的高',
        '解決三角形相關的應用題'
      ],
      sampleQuestions: [
        {
          id: 'p5-5s2-q1',
          question: '三角形的面積公式是什麼？',
          answer: '底 × 高 ÷ 2',
          solution: '三角形的面積 = 底 × 高 ÷ 2',
          difficulty: 'basic'
        },
        {
          id: 'p5-5s2-q2',
          question: '三角形的周長公式是什麼？',
          answer: '三邊之和',
          solution: '三角形的周長 = 三邊之和',
          difficulty: 'basic'
        },
        {
          id: 'p5-5s2-q3',
          question: '一個三角形的底是6厘米，高是4厘米，面積是多少？',
          answer: '12平方厘米',
          solution: '6 × 4 ÷ 2 = 12\n三角形的面積是12平方厘米。',
          difficulty: 'intermediate'
        },
        {
          id: 'p5-5s2-q4',
          question: '一個三角形的三邊分別是3厘米、4厘米、5厘米，周長是多少？',
          answer: '12厘米',
          solution: '3 + 4 + 5 = 12\n三角形的周長是12厘米。',
          difficulty: 'intermediate'
        },
        {
          id: 'p5-5s2-q5',
          question: '一個三角形的面積是20平方厘米，底是8厘米，高是多少？',
          answer: '5厘米',
          solution: '20 × 2 ÷ 8 = 5\n三角形的高是5厘米。',
          difficulty: 'advanced'
        }
      ]
    },
    {
      id: 'p5-5d1',
      code: '5D1',
      title: '圓形圖',
      description: '認識圓形圖的基本概念',
      objectives: [
        '認識圓形圖的概念',
        '學會讀取圓形圖的數據',
        '理解圓形圖的用途',
        '學會簡單的數據分析'
      ],
      sampleQuestions: [
        {
          id: 'p5-5d1-q1',
          question: '圓形圖中，扇形的大小代表什麼？',
          answer: '數量或比例',
          solution: '圓形圖中，扇形的大小代表數量或比例的大小。',
          difficulty: 'basic'
        },
        {
          id: 'p5-5d1-q2',
          question: '如果圓形圖顯示蘋果佔50%，橙子佔30%，香蕉佔20%，哪種水果最多？',
          answer: '蘋果',
          solution: '50% > 30% > 20%，所以蘋果最多。',
          difficulty: 'basic'
        },
        {
          id: 'p5-5d1-q3',
          question: '圓形圖顯示某班級有40人，其中男生佔60%，女生佔40%，男生有多少人？',
          answer: '24人',
          solution: '40 × 60% = 24\n男生有24人。',
          difficulty: 'intermediate'
        },
        {
          id: 'p5-5d1-q4',
          question: '圓形圖顯示某商店銷售額中，食品佔40%，服裝佔35%，其他佔25%，哪類商品銷售額最高？',
          answer: '食品',
          solution: '40% > 35% > 25%，所以食品銷售額最高。',
          difficulty: 'intermediate'
        },
        {
          id: 'p5-5d1-q5',
          question: '圓形圖顯示某班級有50人，其中A組佔30%，B組佔40%，C組佔30%，B組比A組多多少人？',
          answer: '5人',
          solution: 'A組：50 × 30% = 15人\nB組：50 × 40% = 20人\n20 - 15 = 5\nB組比A組多5人。',
          difficulty: 'advanced'
        }
      ]
    },
    {
      id: 'p5-5f1',
      code: '5F1',
      title: '探索與研究',
      description: '通過活動發現數學規律',
      objectives: [
        '培養數學思維能力',
        '學會觀察和發現規律',
        '提高解決問題的能力',
        '培養探索精神'
      ],
      sampleQuestions: [
        {
          id: 'p5-5f1-q1',
          question: '觀察數字：6, 12, 18, 24, 30，下一個數字是什麼？',
          answer: '36',
          solution: '每個數字都比前一個多6，所以下一個是30 + 6 = 36。',
          difficulty: 'basic'
        },
        {
          id: 'p5-5f1-q2',
          question: '用25個相同的正方形可以拼成什麼圖形？',
          answer: '正方形',
          solution: '25個正方形可以拼成一個大正方形，5×5的排列。',
          difficulty: 'intermediate'
        },
        {
          id: 'p5-5f1-q3',
          question: '小明有30個蘋果，每次吃5個，可以吃幾天？',
          answer: '6天',
          solution: '30 ÷ 5 = 6\n30個蘋果，每天吃5個，可以吃6天。',
          difficulty: 'intermediate'
        },
        {
          id: 'p5-5f1-q4',
          question: '找出規律：1, 3, 6, 10, 15, ?',
          answer: '21',
          solution: '每個數字都是前一個加上位置數：1+2=3, 3+3=6, 6+4=10, 10+5=15, 15+6=21',
          difficulty: 'intermediate'
        },
        {
          id: 'p5-5f1-q5',
          question: '用10根相同長度的木棒可以拼成什麼圖形？',
          answer: '正十邊形',
          solution: '10根相同長度的木棒可以拼成正十邊形。',
          difficulty: 'advanced'
        }
      ]
    }
  ]
}; 